import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
});

const withReactQuery = (component: () => ReactNode) => () => {
  return <QueryClientProvider client={client}>{component()}</QueryClientProvider>;
};

export default withReactQuery;
